import styled from '@emotion/styled';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
  margin: 0 auto 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 40px;
  }
`;

export const IconWrap = styled.div`
  margin-bottom: 8px;

  & svg {
    font-size: 56px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    & svg {
      font-size: 88px;
    }
  }
`;

export const Text = styled.p`
  margin: 0;
  font-size: 18px;
  line-height: 1.21;
  font-weight: 700;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 20px;
  }
`;
